import { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from './Loading';
import { FilterAndListBuilder, fetchMoreData } from '../util/listFunctions';
import { RequestParamsModel } from '../models/requestParams.model';
import BaseService from '../services/base.service';
import { ToastService } from '../services/toast.service';
import { ListCardComponent } from './ListCardComponent';

const ListPageCardComponent = ({
  idDataset,
  serviceController,
  legend,
  selectedItem,
  setSelectedItem,
  buttons,
  onStatsChange = null,
  referenceColumn,
  useIndex = false,
  customSelectFunction = null,
  delParams = null,
  deleteSuccessMessage = 'Excluído com sucesso!',
  showModal = false,
  setShowModal = null,
  byId = null,
  fieldId = null,
  //usar referências externas apenas se houver necessidade de trabalhar com elas na pagina que chama o componente
  externalDataSet = null,
  externalDataList = null,
  setExternalDataSet = null,
  setExternalDataList = null,
  selecionarTodos = null,
  toggleSelecionarTodos = null,
  setUltimoSelecionado = null,
  ultimoSelecionado = null,
  orderable = true,
  endpointPath = null,
  showBreadcrumb = true,
  watchFilters = true
}) => {
  const dispatch = useDispatch();
  const filters = useSelector((state: any) => state.filtersToSearch);
  const [dataList, setDataList] = useState({ items: [] });
  const [dataset, setDataset] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [gridColumns, setGridColumns] = useState([]);
  const orderedBy = useSelector((state: any) => state.orderBy);

  const getList = useCallback(
    async (data, isFilter = false, selectAll: boolean = false) => {
      setLoading(true);

      FilterAndListBuilder(
        serviceController,
        data,
        filters,
        setExternalDataList ?? setDataList,
        externalDataList ?? dataList,
        setExternalDataSet ?? setDataset,
        setGridColumns,
        isFilter,
        dispatch,
        selectAll,
        setSelectedItem,
        byId,
        fieldId ?? referenceColumn,
        endpointPath,
        idDataset,
        5
      );

      setLoading(false);
    },
    [
      serviceController,
      filters,
      setExternalDataList,
      externalDataList,
      dataList,
      setExternalDataSet,
      dispatch,
      setSelectedItem,
      endpointPath
    ]
  );

  const selectItem = (index: number) => {
    setSelectedItem(selectedItem === index || index);
  };

  useEffect(() => {
    setSelectedItem(toggleSelecionarTodos ? [] : null);
    getList(RequestParamsModel(idDataset, orderedBy?.direction, orderedBy?.column), true);
  }, [watchFilters ? filters : null, orderedBy, endpointPath]);

  return (
    <>
      {isLoading && <Loading />}
      <ListCardComponent
        breadcrumb={showBreadcrumb}
        idDataset={idDataset}
        legend={legend}
        itemList={externalDataList ?? dataList}
        fetchMoreData={() => {
          fetchMoreData(externalDataSet ?? dataset, getList, idDataset);
        }}
        dataset={externalDataSet ?? dataset}
        gridColumns={gridColumns}
        buttons={buttons}
        onStatsChange={onStatsChange}
        selectItem={customSelectFunction ?? selectItem}
        selectedItems={selectedItem}
        referenceColumn={referenceColumn}
        useIndex={useIndex}
        //Parametros para telas com multipla seleção
        selecionarTodos={selecionarTodos}
        toggleSelecionarTodos={toggleSelecionarTodos}
        setUltimoSelecionado={setUltimoSelecionado}
        setItensSelecionados={setSelectedItem}
        ultimoSelecionado={ultimoSelecionado}
        orderable={orderable}
        order={orderedBy}
        onColumnOrdered={(column, direction) => {
          dispatch({
            type: 'ORDER_BY',
            orderBy: {
              column: column,
              direction: direction,
            },
          });
        }}
      />
    </>
  );
};

export default ListPageCardComponent;
